<template>
    <div class="list-content">
      <div v-if="empty" style="text-align:center">Vacio</div>
      <div v-if="!valid" style="text-align:center">Estructura invalida, utilice componentes '{{childrenTag}}' para renderizar datos</div>
      <slot v-if="valid"></slot>
    </div>
</template>

<script>

export default {
  name: 'list-content',
  data() {
    return {
      valid: false,
      empty: false,
      childrenTag: 'list-content-item'
    }
  },
  mounted() {
    //validate
    if(this.$slots.default.length > 0) {
      var validate = true;
      var childrenTag = this.childrenTag
      this.$slots.default.forEach(slot => {
        if(slot.componentOptions)
          validate &= (slot.componentOptions.tag == childrenTag)
        else 
          validate = false
      });
      this.valid = validate
    } else 
      this.empty = true
  }
}
</script>
